import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => {
  return {
    path: "nps-surveys",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "administrator-tooling" */ "./NpsSurveySetup"
          ),
          import(
            /* webpackChunkName: "administrator-tooling" */ "Tooling/modules/ToolingModule"
          ),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          injectReducer(store, {
            key: "tooling",
            reducer,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
  };
};
